import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage"

const uploadFileToStorage = async (userId, file) => {
  const storage = getStorage()
  const timestamp = Date.now()
  const fileName = file?.name || "file"
  const safeName = fileName.replace(/[\\/]/g, "_")
  const uniqueFileName = `${timestamp}_${safeName}`
  const storageRef = ref(storage, `documents/${userId}/${uniqueFileName}`)

  await uploadBytes(storageRef, file)
  const url = await getDownloadURL(storageRef)

  return { url, uniqueFileName }
}

export const uploadAvatarToStorage = async (userId, file) => {
  const storage = getStorage()
  const storageRef = ref(
    storage,
    `avatars/${userId}`
  )
  await uploadBytes(storageRef, file)
  const url = await getDownloadURL(storageRef)
  return { url }
}

export default uploadFileToStorage
